<template>
  <div>
    <b-modal ref="my-modal" size="xl" hide-footer title="Bin Information (Current Status)">
      <!-- <div class="d-block text-center"> -->
      <!-- <label><b>Bin Information:</b> {{ binTitle }} </label> -->
      <p class="my-4 modalp">{{ binMessage }}</p>
      <!-- </div> -->
      <hr />
      <div class="d-block text-center">
        <div id="display" class="row">
          <div class="col-sm-6 col-md-6 col-lg-6" style="margin-top: 10px;" v-for="(pair, index) in artworks" :key="index">
            <label>Item ID: {{pair.barcode_id}}</label>
            <img v-if="pair.artwork_path.includes('184.169.148.201:3220')" class="thumbnail zoom" style="width: 95%; height: 95%; border: .5px solid #555;" :src="pair.artwork_path.replace('184.169.148.201:3220', 'subprint.printverse.com')" />
            <img v-else class="thumbnail zoom" :src="pair.artwork_path" style="width: 95%; height: 95%; border: .5px solid #555;">
          </div>
        </div>
      </div>
      <!-- <b-button class="mt-3" variant="outline-danger" block @click="hideModal"
        >Close</b-button
      > -->
    </b-modal>
    <div class="row">
      <div class="col-md-6 col-lg-4">
        <h1>Rack: {{ currLocation }} </h1>
      </div>
      <div class="col-md-3 col-lg-3">
        <a href=# @click.prevent="prevPage">
          <div class="icon-container">
            <span class="ti-angle-double-left"></span>
            <span class="icon-name">Prev Rack </span>
          </div>
        </a>
      </div>
      <div class="col-md-3 col-lg-3">
        <a href=# @click.prevent="nextPage">
          <div class="icon-container">
            <span class="icon-name"> Next Rack  </span>
            <span class="ti-angle-double-right"></span>
          </div>
        </a>
      </div>
    </div>
    <div id="display" class="row">
      <div class="col-sm-1 col-md-1 col-lg-1" style="width: 12.499999995%;flex: 0 0 12.499%;max-width: 12.499%;" 
      v-for="index in 48" :key="index">
        <svg :id="'bin' + index"></svg>
      </div>
    </div>
  </div>
</template>
<script>
  import * as shelveOrderService from "../../services/shelveOrder.service";
  import * as d3 from "d3";

  export default {
    data() {
      return {
        data: null,
        racks: null,
        currPage: 0,
        locations: null,
        currLocation: null,
        binMessage: `Testing\n Modal\n For\n Testing\n and\n Stuff.`,
        binContents: {},
        binTitle: "Bin",
        currBin: "",
        options: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F'],
        artworks: null,
      };
    },
    methods: {
      grabRacks: function() {
        shelveOrderService.getBins().then((response) => {
          //console.log("response::: " + JSON.stringify(response));
          this.racks = JSON.parse(response.items[0]['rackMaps']);
          //console.log(this.locations);
          this.locations = Object.keys(this.racks);
          //console.log(this.locations);
          //this.currPage = 0;
          let page = this.locations[this.currPage];
          //console.log(page)
          this.currLocation = page;
          this.populatePage(page);
        })
        .catch((err) => {
          console.log("error barcode: " + JSON.stringify(err.message));
          //this.setUpWarning(JSON.stringify(err.message));
        });
        return;
      },
      nextPage: function() {
        if (this.currPage + 1 >= this.locations.length) {
          return;
        }
        this.currPage += 1;
        this.currLocation = this.locations[this.currPage];
        this.populatePage(this.currLocation)
      },
      prevPage: function() {
        if (this.currPage <= 0) {
          return;
        }
        this.currPage -= 1;
        this.currLocation = this.locations[this.currPage];
        this.populatePage(this.currLocation)
      },
      showModal(bin) {
        //console.log("item: " + JSON.stringify(item));
        //this.reprintOrders.push(item);
        this.binMessage = this.binContents[bin]["text"];
        this.binTitle = bin;
        let barcode = this.binContents[bin]["items"];
        if (this.binContents[bin]["artworks"]) {
          this.artworks = this.binContents[bin]["artworks"];
        } else {
          shelveOrderService.getOrderDetails(barcode).then(response => {
            //console.log(response);
            this.binContents[bin]["artworks"] = response.items['artworks'];
            this.artworks = this.binContents[bin]["artworks"];
          }).catch(err => {
            console.log(err);
          })
        }
        
        this.$refs["my-modal"].show();
      },
      hideModal() {
        this.$refs["my-modal"].hide();
      },
      removeIndexes: function(orders) {
        let spaceIndex = orders.indexOf("spaceArr");
        orders.splice(spaceIndex, 1);

        let usedIndex = orders.indexOf("used");
        orders.splice(usedIndex, 1);

        let barcodesIndex = orders.indexOf("barcodes");
        orders.splice(barcodesIndex, 1);

        let togetherIndex = orders.indexOf("together");
        orders.splice(togetherIndex, 1);

        let newOrders = orders;
        return newOrders;
      },
      createHex: function() {
        let randomNum; 
        let hex = '#';
        while (hex.length < 7) {
          randomNum = Math.floor(Math.random() * 16);
          hex += this.options[randomNum];
        }
        return hex;
      },
      populatePage: function(location) {
        //console.log("Populating Page: ")
        //console.log(location);
        const vueInstance = this;
        let currRack = this.racks[location];
        //console.log(currRack);
        let orders = Object.keys(currRack);
        orders = this.removeIndexes(orders);
        //console.log(orders)
        let mySpaceArr = currRack['spaceArr'];
        let arrCounter = 0;
        let binPrefix = "#bin"
        for (let i=0; i < mySpaceArr.length; i++) {
          for (let j=0; j < mySpaceArr[i].length; j++) {
            arrCounter += 1;
            let currBin = mySpaceArr[i][j];
            let myId = binPrefix + arrCounter;
            //console.log(myId);
            let binText = `${location}${arrCounter}`;
            if (currBin == 0) {
              //console.log("Trying to Populate 1");
              let emptyText = "EMPTY";
              d3.select(myId)
              .append("rect")
              .attr("width", 300)
              .attr("height", 350)
              .style("stroke", "#112233")
              .style("fill", "#FFF")
              .style("stroke-width", 1);
              d3.select(myId)
              .append("text")
              .attr("dx", "0em")
              .attr("dy", "1em")
              .attr("class", "myLabel1")
              .text(binText)
              .style("fill", "#000");
              d3.select(myId)
              .append("text")
              .attr("dx", "5em")
              .attr("dy", "3em")
              .attr('text-anchor', 'middle')
              .attr("class", "myLabel2")
              .text(emptyText)
              .style("fill", "#000");
            } else {
              //console.log("Trying to Populate 2");
              //let myHex = this.createHex();
              //console.log(`${location}${arrCounter}`);
              d3.select(myId)
              .append("rect")
              .attr("class", `rect${location}${arrCounter}`)
              .attr("width", 300)
              .attr("height", 350)
              .style("stroke", "#112233")
              //.attr("fill", myHex)
              //.style("fill", function(d){
              //  console.log(d);
              //  return myColor(d) 
              //})
              .style("stroke-width", 1);
              d3.select(myId)
              .append("text")
              .attr("dx", "0em")
              .attr("dy", "1em")
              .attr("class", "myLabel1")
              .text(binText)
              .style("fill", "#000");
              // var orderG = d3.select(myId).append('g');
              // var anchorModal = orderG.append('a')
              // //.attr('href', '#')
              // .attr('type', 'plants-family')
              // .attr('data-toggle', 'modal')
              // .attr('data-target', '#myModal').style('cursor', 'pointer');
              // anchorModal.append('rect').attr('width', 65).attr('height', 20).attr('x', 1).attr('y', 130).style('fill', '#e3e8e8'); // '#ccc'
              // anchorModal.append('text').text('Expand').attr('x', 5).attr('y', 145)
              // .on('click', function() {
              //   vueInstance.showModal(binText);
              // });
            }
          }
        }
        let currOrder;
        let row;
        let column;
        
        for (let k=0; k < orders.length; k++) {
          let orderId = orders[k];
          //console.log(orderId);
          currOrder = currRack[orderId];
          //console.log("Looking For Order")
          //console.log(currOrder);
          let myHex = this.createHex();
          let binList = currOrder["bins"];
          for (let l=0; l < binList.length; l++) {
            let modalInfo = "";
            let splitStr = binList[l].split("");
            let bin;
            if (splitStr[2]) {
              bin = parseInt(splitStr[1] + splitStr[2], 10);
            } else {
              bin = parseInt(splitStr[1], 10);
            }
            //console.log("Putting Stuff into Bin: " + bin);
            //console.log(bin);

            let binLocation = `${location}${bin}`;
            modalInfo += `BIN: ${binLocation}\n\n`;

            //console.log(binLocation);
            let myId = binPrefix + bin;
            let oIdText = `ORDER_ID: ${orderId}`;
            modalInfo += `${oIdText} ,`;
            modalInfo += ` ALL BINS: ${binList} , `
            d3.select(myId)
            .style("fill", myHex)
            .append("text")
            .attr("dx", "0em")
            .attr("dy", "2em")
            .attr("class", "orderIdText")
            .text(oIdText)
            .style("fill", "#000");
            var orderG = d3.select(myId).append('g');
            var anchorModal = orderG.append('a')
            //.attr('href', '#')
            .attr('type', 'plants-family')
            .attr('data-toggle', 'modal')
            .attr('data-target', '#myModal').style('cursor', 'pointer');
            anchorModal.append('rect').attr('width', 65).attr('height', 20).attr('x', 1).attr('y', 130).style('fill', '#e3e8e8');
            anchorModal.append('text').text('Expand').attr('x', 5).attr('y', 145)
            .style("fill", "#000")
            .on('click', function() {
              vueInstance.showModal(binLocation);
            });
            d3.select(myId)
            .append("text")
            .attr("dx", "0em")
            .attr("dy", "3em")
            .attr("class", "siblingText")
            .text(`Bins: ${binList}`)
            .style("fill", "#000");

            let ship = "FALSE";
            let readyColor = "#0fdbbc";
            if (currOrder["ready"]) {
              ship = "TRUE";
              //console.log(binList[l])
              //d3.selectAll(`.rect${binList[l]}`)
              //.style("stroke", readyColor)
              //.style("stroke-width", '3px');
            }
            let shipText = `SHIP READY: ${ship}`;
            modalInfo += `${shipText}\n\n`;
            d3.select(myId)
            .append("text")
            .attr("dx", "0em")
            .attr("dy", "4em")
            .attr("class", "readyText")
            .text(shipText)
            .style("fill", "#000");

            let totalQty = currOrder["total_qty"];
            let totalQtyText = `Current TotalQty: ${totalQty}`;
            modalInfo += `${totalQtyText}\n\n`;
            d3.select(myId)
            .append("text")
            .attr("dx", "0em")
            .attr("dy", "5em")
            .attr("class", "qtyText")
            .text(totalQtyText)
            .style("fill", "#000");

            let maxQty = currOrder["maxQty"];
            let maxQtyText = `MaxQty: ${maxQty}`;
            modalInfo += `${maxQtyText}\n\n`;

            let itemIds = Object.keys(currOrder);
            let itemCounter = 0;
            let textCounter = 0;
            let xOffset = 0;
            let itemExample;
            modalInfo += `ITEM IDS:\n`;
            for (let h=0; h < itemIds.length; h++) {
              let thisItem = itemIds[h];
              //console.log(thisItem)
              
              if (thisItem != "bins" && thisItem != "total_qty" && thisItem != "ready" && thisItem != "skus" && thisItem != "maxQty") {
                let itemQty = currOrder[thisItem];
                itemExample = thisItem;
                if (itemCounter == 4){
                  itemCounter = 0;
                  xOffset += 5;
                }
                let itemText = `${thisItem}: ${itemQty}`;
                if (textCounter % 3 == 0 && textCounter != 0) {
                  modalInfo += `${itemText}\n`;
                  textCounter = 0;
                } else {
                  modalInfo += `${itemText} , `;
                }
                d3.select(myId)
                .append("text")
                .attr("dx", `${ xOffset }em`)
                .attr("dy", `${6 + itemCounter}em`)
                .attr("class", "itemText")
                .text(itemText)
                .style("fill", "#000");

                itemCounter += 1;
                textCounter += 1;
              }
              
            }
            if (modalInfo.charAt(modalInfo.length-1) == '\n') {
              modalInfo += `\nSKUS: \n`;
            } else {
              modalInfo += `\n\nSKUS: \n`;
            }
            
            textCounter = 0;
            let skuObject = Object.keys(currOrder["skus"]);
            //console.log(skuObject);
            for (let a=0; a < skuObject.length; a++) {
              let thisSku = skuObject[a];
              console.log(thisSku);
              let skuQuantity = currOrder["skus"][thisSku];
              let skuText = `${thisSku}: ${skuQuantity}`;
              if (textCounter % 3 == 0 && textCounter != 0) {
                modalInfo += `${skuText}\n`;
                textCounter = 0;
              } else {
                modalInfo += `${skuText} , `;
              }
            }
            this.binContents[binLocation] = {};
            this.binContents[binLocation]["text"] = modalInfo;
            this.binContents[binLocation]["items"] = itemExample;
            //console.log("BIN Contents");
            //console.log(modalInfo);
            //console.log(this.binContents);
            // row = Math.floor((bin - 1) / 8);
            // column = (bin - 1) % 8;
            // console.log(`Row: ${row}`);
            // console.log(`Column: ${column}`);

          }
          // if (orders[k]) {
          //   console.log("k")
          // }
        }
        return;
      }
    },
    
    beforeMount(){
      this.grabRacks();
    },
  }
  
</script>
<style>
  .modalp {
    word-wrap: break-word;
    white-space: pre-line;
  }

  .gallery{    
    margin-left: 5vw;     
    margin-right:5vw;  
  }    

  .zoom {      
    -webkit-transition: all 0.35s ease-in-out;    
    -moz-transition: all 0.35s ease-in-out;    
    transition: all 0.35s ease-in-out;     
    cursor: -webkit-zoom-in;      
    cursor: -moz-zoom-in;      
    cursor: zoom-in;  
  } 

  .zoom:hover,  
  .zoom:active,   
  .zoom:focus {
    /**adjust scale to desired size, add browser prefixes**/
    -ms-transform: scale(1.5);    
    -moz-transform: scale(1.5);  
    -webkit-transform: scale(1.5);  
    -o-transform: scale(1.5);  
    transform: scale(1.5);    
    position:relative;      
    z-index:100;  
  }

  /**To keep upscaled images visible on mobile, increase left & right margins a bit**/  
  @media only screen and (max-width: 768px) {   
    .gallery {      
      margin-left: 15vw;       
      margin-right: 15vw;
    }

    /**TIP: Easy escape for touch screens,give gallery's parent container a cursor: pointer.**/
    .DivName {
      cursor: pointer
    }
  }

</style>